import { useContext } from 'react';

import { FormContext } from '../FormContext';

export function useAgentForm() {
  return useContext(FormContext);
}
